import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const financeDistributionList = createAsyncThunk(
  'distribution-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}distribution/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeFinanceDistribution = createAsyncThunk(
  'distribution-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}distribution/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getFinanceDistributionById = createAsyncThunk(
  'distribution-get',
  async (distribution_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}distribution/edit/` + distribution_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const approveFinanceDistribution = createAsyncThunk(
  'distribution-approve',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.post(`${api}distribution/approve/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const viewFinanceDistribution = createAsyncThunk(
  'distribution-view',
  async (distribution_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}distribution/view/` + distribution_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getFinanceExistsItemList = createAsyncThunk(
  'distribution-exists-item-list',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}distribution/get-finance-item-stock`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type DistributionState = {
  errors: any
}

const initialState: DistributionState = {
  errors: '',
}

export const distributionSlice = createSlice({
  name: 'distribution',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeFinanceDistribution.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = distributionSlice.actions
export default distributionSlice.reducer
